import store from '@state/store'
import { lazyLoadView } from '@router/helpers'

export default [
  {
    path: '/admin/companies',
    name: 'adminCompanies',
    component: () =>
      lazyLoadView(
        import(/* webpackChunkName: "companies" */ './views/companies.vue')
      ),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/canManageCompanies']()) {
          handleRoute()
        } else {
          next({ name: '404', params: { resource: 'Company' } })
        }
        function handleRoute() {
          store
            // fetch admin companies
            .dispatch('adminCompanies/fetchLists')
            .then(() => {
              next()
            })
            .catch(() => {
              next({ name: '404', params: { resource: 'adminCompanies' } })
            })
        }
      },
    },
  },
  {
    path: '/admin/companies/add',
    name: 'adminCompaniesAdd',
    component: () =>
      lazyLoadView(
        import(
          /* webpackChunkName: "company-form" */
          './views/company-form.vue'
        )
      ),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/canManageCompanies']()) {
          handleRoute()
        } else {
          next({ name: '404', params: { resource: 'Company' } })
        }
        function handleRoute() {
          store
            // fetch admin companies
            .dispatch('adminCompanies/fetchLists')
            .then(() => {
              next()
            })
            .catch(() => {
              next({ name: '404', params: { resource: 'adminCompanies' } })
            })
        }
      },
    },
  },
  {
    path: '/admin/companies/edit/:companyId',
    name: 'adminCompaniesEdit',
    component: () =>
      lazyLoadView(
        import(
          /* webpackChunkName: "company-form" */
          './views/company-form.vue'
        )
      ),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (
          store.getters['auth/canManageCompanies']() ||
          store.getters['auth/canEditCompany'](routeTo.params.companyId)
        ) {
          handleRoute()
        } else {
          next({ name: '404', params: { resource: 'Company' } })
        }
        function handleRoute() {
          store
            // fetch admin companies
            .dispatch('adminCompanies/fetchLists')
            .then(() => {
              next()
            })
            .catch(() => {
              next({ name: '404', params: { resource: 'adminCompanies' } })
            })
        }
      },
    },
    parentName: 'adminCompanies',
    props: (route) => ({
      companyId: route.params.companyId,
    }),
  },
]
